export const MMV_DATA = 'MMV_DATA'
// export const RTO_DATA = 'MMV_DATA'

export const RESET_MMV_DATA = 'RESET_MMV_DATA'
export const LOGGED_USER_DETAILS = 'LOGGED_USER_DETAILS'